import {openResourceModal} from '../../core/modalCommand';
import {LICENSE_UPLOAD_MODAL_EVENT} from './events';

/**
 * Open Upload License - the empty form, with no file chosen.
 *
 * A file input cannot be filled programmatically, so this capability can
 * only ever open the form and hand it over. The person picks the licence
 * file and presses Upload themselves.
 *
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openLicenseUploadModal(command, envelope) {
	return openResourceModal(LICENSE_UPLOAD_MODAL_EVENT, command, envelope);
}
